import React, { forwardRef } from "react"

import { css } from "@jsUtils"

import Styles from "./contentgrid.module.scss"

/**
 * A content row that creates a grid using contentGrid +/- articleGrid
 * Every row must be wrapped in this
 * @param {object} props - react props
 * @param {object|array} props.children - child nodes
 * @param {string} props.extraClass - theme or other class to use
 * @param {string} props.gridName - name of style to use
 */
const ContentRow = forwardRef((props, ref) => {
  const { children, gridName = "articleGrid", extraClass, override = ``, tagname } = props

  const TagName = tagname || "section"

  return (
    <TagName ref={ref} className={css(Styles[gridName], extraClass, override)}>
      {children}
    </TagName>
  )
})

export default ContentRow
